<template lang="pug">
v-card.custom-card.placeholder-card(outlined)
  v-card-title.custom-card-title.d-flex.align-center.justify-space-between.flex-wrap.gap-2.py-2
    span.tree-title {{ titulo }}
    .blue--text.text--darken-3 {{ nomeItem || "—" }}
    v-tooltip(v-if="totalClientes > 0", bottom)
      template(v-slot:activator="{ on, attrs }")
        v-chip.cliente-clientes-count(
          v-bind="attrs",
          v-on="on",
          color="teal",
          text-color="white",
          small,
          label
        ) {{ totalClientes }} Clientes
      span {{ totalClientes }} {{ tooltipClientes }}
    v-tooltip(v-if="totalEmpresas > 0", bottom)
      template(v-slot:activator="{ on, attrs }")
        v-chip.cliente-empresas-count(
          v-bind="attrs",
          v-on="on",
          color="primary",
          text-color="white",
          small,
          label
        ) {{ totalEmpresas }} Empresas
      span {{ totalEmpresas }} {{ tooltipEmpresas }}
    v-spacer
    v-btn.btn-action.text-none(
      outlined,
      small,
      :disabled="!clientes.length",
      @click="$emit('expandir')"
    ) {{ textoExpandir }}
    v-btn.btn-action.text-none(
      outlined,
      small,
      :disabled="!clientes.length",
      @click="$emit('recolher')"
    ) {{ textoRecolher }}
  v-progress-linear.clientes-loading-bar(
    v-if="carregando",
    indeterminate,
    color="blue",
    height="2"
  )
  v-card-text.placeholder-card-content.ma-0.pa-0
    //- Estado: nada selecionado / nó não-folha
    .clientes-empty.justify-center.align-center.text-center.py-8(
      v-if="!temSelecao || !temDados"
    )
      v-icon.empty-state-icon(
        size="48",
        color="blue lighten-3"
      ) {{ iconeSemSelecao }}
      .empty-state-title.mt-3 {{ tituloSemSelecao }}
      .empty-state-subtitle.mt-1(
        v-if="temSelecao"
      ) {{ textoNaoFolha }}
      .empty-state-subtitle.mt-1(v-else) {{ textoSemSelecao }}

    template(v-else)
      .clientes-search.pa-3
        v-text-field.preview-field(
          :value="busca",
          :placeholder="placeholderBusca",
          prepend-inner-icon="mdi-magnify",
          rounded,
          filled,
          dense,
          hide-details,
          clearable,
          @input="$emit('update:busca', $event)"
        )

      //- Estado: busca sem resultado
      .clientes-empty.justify-center.align-center.text-center.py-8(
        v-if="clientes.length === 0 && buscaAplicada"
      )
        v-icon.empty-state-icon(
          size="48",
          color="blue lighten-3"
        ) mdi-file-search-outline
        .empty-state-title.mt-3 Nenhum resultado
        .empty-state-subtitle.mt-1
          | {{ textoSemResultado }} &quot;{{ buscaAplicada }}&quot;.

      //- Estado: item sem clientes vinculados
      .clientes-empty.justify-center.align-center.text-center.py-8(
        v-else-if="totalItens === 0"
      )
        v-icon.empty-state-icon(
          size="48",
          color="blue lighten-3"
        ) mdi-account-search-outline
        .empty-state-title.mt-3 Nenhum cliente encontrado
        .empty-state-subtitle.mt-1 {{ textoSemClientes }}

      //- Estado: clientes carregados — accordion por cliente
      .clientes-expansion-wrapper.py-2.px-4(
        v-if="clientes.length > 0"
      )
        v-expansion-panels.clientes-panels(
          :value="value",
          @change="$emit('input', $event)",
          multiple,
          elevation="0"
        )
          v-expansion-panel.cliente-panel(
            v-for="(cliente, idx) in clientes",
            :key="cliente.idcliente || idx",
            elevation="0"
          )
            v-expansion-panel-header.cliente-header.py-2.px-3
              template(v-slot:actions)
                v-icon(color="primary") $expand
              .cliente-header-content.d-flex
                .cliente-nome.text-truncate(:title="cliente.nome") {{ cliente.nome }}
                v-tooltip(
                  v-if="cliente.empresas && cliente.empresas.length > 0",
                  bottom
                )
                  template(v-slot:activator="{ on, attrs }")
                    .cliente-empresas-count(
                      v-bind="attrs",
                      v-on="on"
                    ) {{ cliente.empresas.length }}
                  span {{ cliente.empresas.length }} empresa(s)
                v-tooltip(v-if="cliente.versaobase", bottom)
                  template(v-slot:activator="{ on, attrs }")
                    v-chip.cliente-versaobase-chip.mt-0.mr-2(
                      v-bind="attrs",
                      v-on="on",
                      x-small,
                      outlined,
                      color="blue lighten-4",
                      text-color="blue darken-3",
                      label,
                      style="width: 75px"
                    ) {{ cliente.versaobase }}
                  span Versão da base: {{ cliente.versaobase }}

            v-expansion-panel-content
              //- Mensagem caso o cliente não tenha empresas
              .cliente-sem-empresas.text-center.text-body-2.py-4(
                v-if="!cliente.empresas || cliente.empresas.length === 0"
              )
                v-icon.mb-1(small, color="grey") mdi-domain
                .text-body-2.grey--text Cliente sem empresas vinculadas.

              //- Lista de empresas (v-list por empresa)
              v-list.empresas-list.ma-0.pa-0(v-else, dense)
                v-list-item.empresa-listitem(
                  v-for="empresa in cliente.empresas",
                  :key="empresa.idempresa || empresa.codigoempresa"
                )
                  v-list-item-content
                    v-list-item-title.empresa-linha-1.d-flex.align-center.text-body-2
                      .empresa-codigo.mr-2 {{ empresa.codigoempresa }}
                      span.empresa-fantasia.font-weight-medium.ml-1 {{ empresa.fantasia || empresa.razaosocial }}
                      v-spacer
                      v-chip.empresa-tipo-chip.ml-2(
                        x-small,
                        outlined
                      ) {{ empresa.dstipoempresa }}
</template>

<script>
export default {
  name: "ClientesVinculadosCard",

  props: {
    value: {
      type: Array,
      default: () => []
    },
    titulo: {
      type: String,
      default: "Item Selecionado:"
    },
    nomeItem: {
      type: String,
      default: ""
    },
    clientes: {
      type: Array,
      default: () => []
    },
    totalItens: {
      type: Number,
      default: 0
    },
    totalClientes: {
      type: Number,
      default: 0
    },
    totalEmpresas: {
      type: Number,
      default: 0
    },
    carregando: {
      type: Boolean,
      default: false
    },
    temSelecao: {
      type: Boolean,
      default: false
    },
    temDados: {
      type: Boolean,
      default: false
    },
    busca: {
      type: String,
      default: ""
    },
    buscaAplicada: {
      type: String,
      default: ""
    },
    placeholderBusca: {
      type: String,
      default: "Localizar cliente, empresa ou versão..."
    },
    iconeSemSelecao: {
      type: String,
      default: "mdi-file-tree"
    },
    tituloSemSelecao: {
      type: String,
      default: "Selecione um item"
    },
    textoSemSelecao: {
      type: String,
      default: "Clique em um item na árvore para ver as empresas que utilizam."
    },
    textoNaoFolha: {
      type: String,
      default: "Este item não é um item folha da árvore."
    },
    textoSemResultado: {
      type: String,
      default: "Nenhum cliente, empresa ou versão corresponde a"
    },
    textoSemClientes: {
      type: String,
      default: "Nenhum cliente está vinculado a este item."
    },
    tooltipClientes: {
      type: String,
      default: "cliente(s) que ao menos 1 empresa vincula a este item"
    },
    tooltipEmpresas: {
      type: String,
      default: "empresa(s) vinculada(s) a este item"
    },
    textoExpandir: {
      type: String,
      default: "Expandir"
    },
    textoRecolher: {
      type: String,
      default: "Recolher"
    }
  }
};
</script>

<style scoped>
.custom-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
  background-color: #fff;
  border: 1px solid #d9e2ec !important;
  border-radius: 18px 6px 18px 6px !important;
  box-shadow: 0 2px 8px rgba(15, 42, 77, 0.08) !important;
}

.custom-card-title {
  flex: 0 0 auto;
  min-height: 56px;
  padding: 0 18px;
  display: flex;
  align-items: center;
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
  background-color: #e3f2fd;
  border-radius: 18px 6px 0 0;
}

.tree-title {
  color: #0f2b57;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.3;
}

.btn-action {
  height: 30px !important;
  min-width: 0 !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: 0.01em !important;
  border: 1px solid #d0d7de !important;
  color: #57606a !important;
  background-color: #ffffff !important;
  font-weight: 500 !important;
  border-radius: 6px !important;
}

.text-none {
  text-transform: none !important;
}

.preview-field {
  border-radius: 6px !important;
  background-color: #fff;
}

.preview-field.v-input--is-focused .v-input__slot {
  border-color: #1976d2 !important;
  box-shadow: 0 0 0 1px rgba(25, 118, 210, 0.15);
}

.preview-field .v-input__slot:hover {
  border-color: #b1bac4;
}

.preview-field .v-input__slot,
.preview-field .v-text-field__slot input {
  font-size: 13px;
  color: #2c3e50;
  font-weight: 500;
  min-height: 36px !important;
}

.preview-field .v-input__prepend-inner .v-icon,
.preview-field .v-input__append-inner .v-icon {
  color: #57606a;
  font-size: 18px;
}

.gap-2 {
  gap: 8px;
}

.placeholder-card {
  display: flex;
  flex-direction: column;
}

/* Contêiner flex: o scroll pertence ao wrapper interno, nunca aqui. */
.placeholder-card-content {
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.clientes-loading-bar {
  position: absolute;
  top: 56px;
  left: 0;
  right: 0;
  z-index: 2;
}

.clientes-search {
  flex: 0 0 auto;
}

.clientes-empty {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  color: #999;
  font-size: 14px;
}

.empty-state-icon {
  opacity: 0.6;
}

.empty-state-title {
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.empty-state-subtitle {
  font-size: 12px;
  color: #777;
  max-width: 260px;
  margin: 0 auto;
  line-height: 1.4;
}

.cliente-sem-empresas {
  color: #999;
}

/* flex-basis 0 (e não auto): a altura vem da distribuição do flex, de cima
   para baixo, sem o navegador medir os milhares de itens do conteúdo. */
.clientes-expansion-wrapper {
  flex: 1 1 0;
  min-height: 0;
  overflow-y: auto;
  scrollbar-width: thin;
}

.cliente-header-content {
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.cliente-nome {
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: #2c3e50;
}

.cliente-versaobase-chip {
  flex-shrink: 0;
}

.cliente-empresas-count {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background-color: #1976d2;
  letter-spacing: 0.3px;
}

.cliente-clientes-count {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 22px;
  padding: 0 6px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background-color: #00897b;
  letter-spacing: 0.3px;
}

.empresas-list {
  background-color: #fafbfc;
}

.empresa-listitem {
  border-bottom: 1px solid #eef0f3;
}

.empresa-listitem:last-child {
  border-bottom: none;
}

.empresa-codigo {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 30px;
  height: 30px;
  padding: 0 8px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #ffffff;
  background-color: #1976d2;
  letter-spacing: 0.3px;
}

.empresa-fantasia {
  color: #2c3e50;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

.empresa-tipo-chip {
  font-size: 10px !important;
  height: 18px !important;
  background-color: #ffffff !important;
}

.cliente-panel ::v-deep .v-expansion-panel-content__wrap {
  padding: 0px 0px 0px 0px;
}
</style>
